import { useState } from 'react';
import Logo from './Logo';

const LINKS = [
  { id: 'features', label: 'Features' },
  { id: 'sports', label: 'Sports' },
  { id: 'plans', label: 'Plans' },
  { id: 'about', label: 'About' },
];

interface HeaderProps {
  /** section currently in view, from the scrollspy */
  activeId: string;
  stuck: boolean;
}

export default function Header({ activeId, stuck }: HeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={`site-header${stuck ? ' is-stuck' : ''}`}>
      <div className="header-inner">
        <a className="brand" href="#top" aria-label="PlaySlot home">
          <Logo size={34} motion="idle" />
          <span className="brand-name">PlaySlot</span>
        </a>

        <nav className="nav" aria-label="Primary">
          {LINKS.map(({ id, label }) => (
            <a
              key={id}
              href={`#${id}`}
              className={activeId === id ? 'is-active' : undefined}
            >
              {label}
            </a>
          ))}
        </nav>

        <a className="btn btn-primary btn-sm" href="#demo">
          Request a Demo
        </a>

        <button
          className="nav-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="mobile-nav"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="sr-only">{menuOpen ? 'Close menu' : 'Open menu'}</span>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            stroke="#F4F6F2"
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
            aria-hidden="true"
          >
            {menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 8h16M4 16h16" />}
          </svg>
        </button>
      </div>

      <div
        className={`mobile-nav${menuOpen ? ' open' : ''}`}
        id="mobile-nav"
        onClick={(e) => {
          if ((e.target as HTMLElement).closest('a')) setMenuOpen(false);
        }}
      >
        {LINKS.map(({ id, label }) => (
          <a key={id} href={`#${id}`}>
            {label}
          </a>
        ))}
        <a className="btn btn-primary btn-block" href="#demo">
          Request a Demo
        </a>
      </div>
    </header>
  );
}
